import { Injectable } from '@angular/core';
import { NavController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(
    private toast: ToastController,
    private navController: NavController
    ) { }

  public async standardError(error, duration: number = 4000, position: Position = 'bottom') {
    let msg = '';
    if (error.status === 0) {
      msg = 'Check your internet connection, I could not reach the server.';
    } else {
      msg = error.error.message;
    }
    const toast = await this.toast.create({
      message: msg,
      header: error.statusText,
      duration,
      position,
    });
    await toast.present();
  }

  public async optionMessage(msg, head, duration: number = 20000, position: Position = 'bottom') {
    const toast = await this.toast.create({
      message: msg,
      header: head,
      duration,
      position,
      cssClass: 'bottom-toast',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // Handle the cancel button click here (e.g., close the toast)
            toast.dismiss();
          }
        }
      ]
    });

    await toast.present();
  }

public async customizationActionError(error, duration: number = 4000, position: Position = 'bottom') {
  let msg = '';

  if (error.status === 0) {
    msg = 'Check your internet connection, I could not reach the server.';
    const toast = await this.toast.create({
      message: msg,
      header: error.statusText,
      duration,
      position,
    });
    await toast.present();
  } else if (error.error.message.includes('Duplicate entry')) {
      return new Promise<boolean>(async (resolve) => {
        const alert = await this.toast.create({
          header: 'Duplicate Entry',
          message: 'This action already exists. Do you want to overwrite it?',
          buttons: [
            {
              text: 'No',
              role: 'cancel',
              handler: () => {
                resolve(false); // Return false if "No" is chosen
              }
            },
            {
              text: 'Yes',
              handler: () => {
                resolve(true); // Return true if "Yes" is chosen
              }
            }
          ]
      });
      await alert.present();
    });
  }  else {
    msg = error.error.message;
    const toast = await this.toast.create({
      message: msg,
      header: error.statusText,
      duration,
      position,
    });
    await toast.present();
  }
}

public async invalidScopes(error, duration: number = 4000, position: Position = 'bottom'){
  let msg = '';

  if (error.status === 0) {
    msg = 'Check your internet connection, I could not reach the server.';
    const toast = await this.toast.create({
      message: msg,
      header: error.statusText,
      duration,
      position,
    });
    await toast.present();
  } else if (error.error.message.includes('Invalid scope')) {
    this.navController.navigateRoot('/launch');

  }  else {
    msg = error.error.message;
    const toast = await this.toast.create({
      message: msg,
      header: error.statusText,
      duration,
      position,
    });
    await toast.present();
  }

}

  public async message(msg, head, duration: number = 4000, position: Position = 'top') {
    const toast = await this.toast.create({
      message: msg,
      header: head,
      duration,
      position,
    });
    await toast.present();
  }

  public async optionError(error, optIcon, optText, position: Position = 'top') {
    let msg = '';
    if (error.status === 0) {
      msg = 'Check your internet connection, I could not reach the server.';
    } else {
      msg = error.error.message;
    }
    const toast = await this.toast.create({
      header: error.statusText,
      message: msg,
      icon: 'information-circle',
      position,
      buttons: [
        {
          side: 'start',
          icon: optIcon,
          text: optText,
        }, {
          text: 'Cancel',
          role: 'cancel',
        }
      ]
    });
    await toast.present();

    const {role} = await toast.onDidDismiss();
  }

  public async optionToast(message, header, optIcon, optText, handler = () => {}, position: Position = 'top') {
    const toast = await this.toast.create({
      header,
      message,
      position,
      buttons: [
        {
          side: 'start',
          icon: optIcon,
          text: optText,
          handler,
        }, {
          text: 'Cancel',
          role: 'cancel',
        }
      ]
    });
    await toast.present();
  }

  public async positiveFeedback(message, header, duration: number = 2000, position: Position = 'top') {
    const toast = await this.toast.create({
      message,
      header,
      duration,
      position,
    });
    await toast.present();
  }
}

export type Position = 'top' | 'bottom' | 'middle';

